export default milliseconds => milliseconds / 1000 / 60 / 60;
